export default {
    facebook: 'https://www.facebook.com/heavenuponricefields?mibextid=kFxxJD',
    whatsapp: 'https://wa.me/94712653653',
    instagram: "https://www.instagram.com/heavenuponricefield_lk?igsh=N3RxdXYyMXA1aXdm",
    tripadvisor: "https://www.tripadvisor.com/Hotel_Review-g304132-d9805218-Reviews-Heaven_Upon_Rice_Fields-Anuradhapura_North_Central_Province.html",
    youtube: 'https://www.youtube.com/@HeavenUponRiceFields',
    booking: 'https://www.booking.com/Share-zt61xR'
}